import { useState } from 'react';

export const useEmailAction = (handleUpdateEmailAction, handleResendEmail, refetchDetails) => {
  const [openModal, setOpenModal] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpenModal(true);

  const handleClose = () => {
    setOpenModal(false);
    setNewEmail('');
    setConfirmEmail('');
    setError('');
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmitEmailChange = async () => {
    setError('');
    setLoading(true);
    if (!newEmail || !confirmEmail) {
      setError('Ambos campos son obligatorios.');
      setLoading(false);
      return;
    }
    if (newEmail !== confirmEmail) {
      setError('Los correos electrónicos no coinciden.');
      setLoading(false);
      return;
    }
    if (!validateEmail(newEmail)) {
      setError('Por favor, ingrese un correo electrónico válido.');
      setLoading(false);
      return;
    }

    try {
      await handleUpdateEmailAction(newEmail);
      await handleResendEmail('Correo cambiado y reenviado exitosamente!');
      refetchDetails();
      handleClose();
    } catch (err) {
      setError('Error al actualizar el correo. Intente nuevamente.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    openModal,
    newEmail,
    setNewEmail,
    confirmEmail,
    setConfirmEmail,
    error,
    loading,
    handleOpen,
    handleClose,
    handleSubmitEmailChange,
  };
};
